export default { sha: '2ef585da8fc6a5a7c4dd8ba3105b0f8118902db4', buildNumber: 'undefined' }
